<template >
  <div class="container-fluid" v-if="lesson">
    <div class="row">
      <div class="col-lg-4">
        <div class="card mb-4">
          <div class="card-header">
            <h2>{{lesson.name}}</h2>
            <!-- <div class="row">
              <div class="col-lg-2">
                <div class="btn btn-info btn-sm">
                  <router-link
                    :to="{ name: 'LessonEdit', params: { lessonId: lesson.id}}"
                    class="text-white"
                  >Засах</router-link>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="btn btn-warning btn-sm">
                <router-link
                  :to="{ name: 'ImageAdd', params: { objectPath: 'lessons/'+lesson.id}}"
                >Зураг оруулах</router-link>
              </div>
              </div>
            </div> -->
          </div>
          <div class="card-body">
            <p>{{lesson.description}}</p>
            <br />
             <p v-if="lesson.semester">Төрөл: {{lesson.semester.id}}</p>
            <p v-if="lesson.credit">Үлдэгдэл: {{lesson.amount}}</p>
            <p v-if="lesson.school">Үндсэн ангилал: {{lesson.school.id}}</p>
            <p v-if="lesson.department">Төрөл: {{lesson.department.id}}</p>
            <p v-if="lesson.program">Дэд төрөл: {{lesson.program.id}}</p>
            <br />
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <button
                  class="btn btn-outline-secondary btn-sm"
                  type="button"
                  v-for="type in lesson.types"
                >{{type}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-8">
<div class="card mb-4">
      <div class="card-header row m-0">
        <div class="col">
          <h4 class="text-center">Нэмэлт мэдээлэл</h4>
        </div>
        <div class="col col-auto">
          <h4
            v-if="lesson.published==true"
            style="cursor:pointer"
            @click="setPublished(false,lesson)"
          >
            <span class="badge badge-success">Нээлттэй</span>
          </h4>
          <h4 v-else @click="setPublished(true,lesson)" style="cursor:pointer">
            <span class="badge badge-danger">Хаалттай</span>
          </h4>
        </div>
      </div>
      <div class="card-body">
        <div
          class="row text-center text-lg-left mt-5"
          v-if="lesson.images!=null && lesson.images.length>0"
        >
          <div
            class="col-lg-3 col-md-4 col-6"
            v-for="(file) in lesson.images"
            v-bind:key="file.fileUrl"
          >
            <a href="#" class="d-block mb-4 h-100">
              <img class="img-fluid" :src="file.fileUrl" />
            </a>
          </div>
        </div>
        <div class="my-4" v-if="lesson.results!=null && lesson.results.length>0">
          <h4>Тэмдэглэгээ</h4>
          <ul>
            <li v-for="(include) in lesson.results" v-bind:key="include">{{include}}</li>
          </ul>
        </div>
      </div>
    </div>
      </div>
    </div>

    
    <hr class="mb-5" />

    <!-- Modal -->
    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Сэдэв нэмэхd</h5>

            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="user">
              <div class="form-group">
                <input
                  v-model.trim="topic.name"
                  class="form-control"
                  id="exampleInputEmail"
                  aria-describedby="emailHelp"
                  placeholder="Сэдвийн нэр"
                />
              </div>
              <div class="form-group">
                <textarea
                  rows="10"
                  v-model.trim="topic.description"
                  class="form-control"
                  id="exampleInputPassword"
                  placeholder="Сэдвийн дэлгэрэнгүй"
                />
              </div>

              <hr />
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button
              @click="saveTopic"
              type="button"
              class="btn btn-primary btn-user btn-block"
              data-dismiss="modal"
            >Save</button>
          </div>
        </div>
      </div>
    </div>

    <!-- ContentModal -->
    <div
      class="modal fade"
      id="contentModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="contentModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Агуулга нэмэх</h5>

            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="user">
              <div class="form-group">
                <label>Агуулгын нэр:</label>
                <input v-model.trim="content.name" class="form-control" placeholder="Агуулгын нэр" />
              </div>
              <div class="form-group">
                <label>Агуулгын дэлгэрэнгүй тайлбар:</label>
                <textarea
                  rows="10"
                  v-model.trim="content.description"
                  class="form-control"
                  placeholder="Агуулгын дэлгэрэнгүй"
                />
              </div>
              <div class="form-group">
                <label>Youtube видеоны линк:</label>
                <input
                  v-model.trim="content.videoUrl"
                  class="form-control"
                  placeholder="Видеоны линк"
                />
              </div>
              <div class="form-group">
                <label for="exampleFormControlSelect1">Агуулгын төрөл:</label>
                <select class="form-control" v-model="selectedType">
                  <option
                    v-for="(type) in types"
                    v-bind:key="type.id"
                    v-bind:value="type.id"
                  >{{type.title}}</option>
                </select>
              </div>

              <hr />
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Хаах</button>
            <button
              @click="saveContent(selectedTopic)"
              type="button"
              class="btn btn-primary btn-user btn-block"
            >Хадгалах</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require("../../firebaseConfig.js");
import { mapState } from "vuex";
import moment from "moment";
import firebase from "firebase";

export default {
  name: "LessonDetail",

  data() {
    return {
      lesson: null,
      topic: {
        name: null,
        description: null
      },
      content: {
        name: null,
        description: null,
        videoUrl: null
      },
      topics: [],
      types: [],
      selectedType: null,
      studentsText: "",
      selectedTopic: null,
      tmpStudents: [],
      tmpAdditionalFile: {
        name: "",
        uploading: false,
        uploadPercent: null
      },
      lessonBucket: "lessonFiles/",
      topicBucket: "lessonTopicFiles/"
    };
  },
  methods: {
    _getQA() {
      fb.db
        .collection("ContentTypes")
        .get()
        .then(querySnapshot => {
          this.types = [];
          querySnapshot.forEach(doc => {
            let object = doc.data();
            object.id = doc.id;
            object.content = [];
            this.types.push(object);
            this._getContents(object);
          });
        });

      fb.db
        .collection("lessons")
        .doc(this.lessonId)
        .onSnapshot(doc => {
          let lesson = doc.data();
          lesson.id = doc.id;
          this.lesson = lesson;
        });

      fb.db
        .collection("lessons/" + this.lessonId + "/studentList")
        .onSnapshot(querySnapshot => {
          this.tmpStudents = [];
          querySnapshot.forEach(stddata => {
            let object = stddata.data();
            object.id = stddata.id;
            object.student = null;
            object.ref = stddata.ref;
            if (stddata.data().studentRef != null) {
              stddata
                .data()
                .studentRef.get()
                .then(studentDoc => {
                  object.student = studentDoc.data();
                });
            }
            this.tmpStudents.push(object);
          });
        });

      fb.db
        .collection("lessons")
        .doc(this.lessonId)
        .collection("topics")
        .orderBy("createdAt", "desc")
        .onSnapshot(querySnapshot => {
          this.topics = [];
          querySnapshot.forEach(doc => {
            let object = doc.data();
            object.id = doc.id;
            object.details = [];
            doc.ref
              .collection("details")
              .orderBy("createdAt")
              .onSnapshot(contentSnapshot => {
                object.details = [];
                contentSnapshot.forEach(contentDoc => {
                  let content = contentDoc.data();
                  content.id = contentDoc.id;
                  content.uploading = false;
                  content.uploadPercent = 0;
                  object.details.push(content);
                });
              });
            this.topics.push(object);
          });
        });
    },
    _getContents(type) {
      if (type.content == null || type.content == undefined) type.content = [];
      fb.db
        .collection("lessons/" + this.lessonId + "/" + type.id)
        .orderBy("createdAt")
        .onSnapshot(querySnapshot => {
          type.content = [];
          querySnapshot.forEach(function(doc) {
            let object = doc.data();
            object.id = doc.id;
            object.uploading = false;
            object.uploadPercent = 0;
            type.content.push(object);
          });
        });
    },
    saveTopic() {
      if (
        this.lesson != null &&
        this.topic != null &&
        this.topic.name != "" &&
        this.topic.description != ""
      ) {
        if (
          this.topic.id != null &&
          this.topic.id != "" &&
          this.topic.id != "new"
        ) {
          this.topic.modifiedAt = new Date();
          fb.db
            .collection("lessons")
            .doc(this.lessonId)
            .collection("topics")
            .doc(this.topic.id)
            .update(this.topic);
        } else {
          var now = new Date();
          this.topic.createdAt = now;

          fb.db
            .collection("lessons")
            .doc(this.lessonId)
            .collection("topics")
            .doc()
            .set(this.topic);
          fb.db
            .collection("lessons")
            .doc(this.lessonId)
            .update({
              numberOfTopics: fb.firestore.FieldValue.increment(1)
            });
        }
        this.topic = {
          name: null,
          description: null
        };
      }
    },
    saveContent(topic) {
      if (
        this.content != null &&
        this.content.name != null &&
        this.content.name != "" &&
        this.selectedType != null
      ) {
        if (this.content.videoUrl != null && this.content.videoUrl != "") {
          if (this.content.videoUrl.toLowerCase().indexOf("youtube") == -1) {
            alert("Та заавал youtube бичлэг оруулна уу");
            return;
          }
        }
        this.content.typeRef = fb.db
          .collection("ContentTypes")
          .doc(this.selectedType);
        this.content.type = this.selectedType;

        if (
          this.lesson != null &&
          topic != null &&
          topic.id != null &&
          this.content != null &&
          this.content != undefined
        ) {
          if (
            this.content.id != undefined &&
            this.content.id != null &&
            this.content.id != "" &&
            this.content.id != "new"
          ) {
            this.content.modifiedAt = new Date();
            fb.db
              .collection("lessons")
              .doc(this.lessonId)
              .collection("topics")
              .doc(topic.id)
              .collection("details")
              .doc(this.content.id)
              .update(this.content);
          } else {
            this.content.createdAt = new Date();
            fb.db
              .collection("lessons")
              .doc(this.lessonId)
              .collection("topics")
              .doc(topic.id)
              .collection("details")
              .doc()
              .set(this.content);
            fb.db
              .collection("lessons")
              .doc(this.lessonId)
              .collection("topics")
              .doc(topic.id)
              .update({
                numberOfContent: fb.firestore.FieldValue.increment(1)
              });

            fb.db
              .collection("lessons")
              .doc(this.lessonId)
              .update({
                numberOfContent: fb.firestore.FieldValue.increment(1)
              });

            if (this.content.videoUrl != null && this.content.videoUrl != "") {
              fb.db
                .collection("lessons")
                .doc(this.lessonId)
                .update({
                  numberOfVideos: fb.firestore.FieldValue.increment(1)
                });
            }
          }

          this.selectedType = null;
          this.selectedTopic = null;
          this.content = {
            name: null,
            description: null,
            videoUrl: null
          };
        }
        $("#contentModal").modal("hide");
      } else {
        alert("Та талбаруудыг гүйцэд бөглөнө үү");
      }
    },
    openSaveContentModal(topic) {
      this.selectedTopic = topic;
      $("#contentModal").modal("show");
    },
    uploadFile(topic, content) {
      var _this = this;
      var files = this.$refs["file_" + content.id][0].files;
      if (files != null && files.length > 0) {
        var file = files[0];
        if (
          file.name.endsWith("mp4") ||
          file.name.endsWith("MP4") ||
          file.name.endsWith("MPEG") ||
          file.name.endsWith("mov") ||
          file.name.endsWith("MOV") ||
          file.name.endsWith("webm") ||
          file.name.endsWith("WEBM")
        ) {
          alert("Та video файл оруулах боломжгүй");
          return;
        }
        var now = new Date();
        var uploadTask = fb.storageRef
          .child(this.topicBucket + now.getTime() + "_" + file.name)
          .put(file);
        content.uploading = true;
        content.uploadPercent = 0;
        uploadTask.on(
          fb.storage.TaskEvent.STATE_CHANGED,
          function(snapshot) {
            var progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            content.uploadPercent = progress;
          },
          function(error) {
            switch (error.code) {
              case "storage/unauthorized":
                break;

              case "storage/canceled":
                break;
              case "storage/unknown":
                break;
            }
          },
          function() {
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then(function(downloadURL) {
                let fileObject = {
                  fileName: file.name,
                  fileUrl: downloadURL,
                  uploadedAt: now
                };
                fb.db
                  .collection("lessons")
                  .doc(_this.lessonId)
                  .collection("topics")
                  .doc(topic.id)
                  .collection("details")
                  .doc(content.id)
                  .update({
                    files: fb.firestore.FieldValue.arrayUnion(fileObject)
                  });
                content.uploading = false;
                content.uploadPercent = 0;
              });
          }
        );
      }
    },
    uploadFile1() {
      if (
        this.tmpAdditionalFile.name != null &&
        this.tmpAdditionalFile.name != ""
      ) {
        var _this = this;
        var files = this.$refs["lessonFile_" + this.lesson.id].files;

        if (files != null && files.length > 0) {
          var file = files[0];
          if (
            file.name.endsWith("mp4") ||
            file.name.endsWith("MP4") ||
            file.name.endsWith("MPEG") ||
            file.name.endsWith("mov") ||
            file.name.endsWith("MOV") ||
            file.name.endsWith("webm") ||
            file.name.endsWith("WEBM")
          ) {
            alert("Та video файл оруулах боломжгүй");
            return;
          }
          var now = new Date();
          var uploadTask = fb.storageRef
            .child(this.lessonBucket + now.getTime() + "_" + file.name)
            .put(file);
          _this.tmpAdditionalFile.uploading = true;
          _this.tmpAdditionalFile.uploadPercent = 0;
          uploadTask.on(
            fb.storage.TaskEvent.STATE_CHANGED,
            function(snapshot) {
              var progress =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              _this.tmpAdditionalFile.uploadPercent = progress;
            },
            function(error) {
              // https://firebase.google.com/docs/storage/web/handle-errors
              switch (error.code) {
                case "storage/unauthorized":
                  break;

                case "storage/canceled":
                  break;

                case "storage/unknown":
                  break;
              }
            },
            function() {
              uploadTask.snapshot.ref
                .getDownloadURL()
                .then(function(downloadURL) {
                  let fileObject = {
                    title: _this.tmpAdditionalFile.name,
                    fileName: file.name,
                    fileUrl: downloadURL,
                    uploadedAt: now
                  };
                  fb.db
                    .collection("lessons")
                    .doc(_this.lessonId)
                    .update({
                      files: fb.firestore.FieldValue.arrayUnion(fileObject)
                    });

                  _this.tmpAdditionalFile = {
                    name: "",
                    uploading: false,
                    uploadPercent: null
                  };
                  _this.$refs["lessonFile_" + _this.lesson.id].value = "";

                  if (!/safari/i.test(navigator.userAgent)) {
                    _this.$refs["lessonFile_" + _this.lesson.id].type = "";
                    _this.$refs["lessonFile_" + _this.lesson.id].type = "file";
                  }
                });
            }
          );
        }
      }
    },
    goStat(type, topic) {
      this.$router.push({
        name: "TopicStat",
        params: { lessonId: this.lessonId, type: type.id, topicId: topic.id }
      });
    },
    addStudents() {
      if (this.studentsText != null && this.studentsText != "") {
        var arrayOfLines = this.studentsText.match(/[^\r\n]+/g);
        arrayOfLines.forEach(value => {
          // console.log(value);
          var lineArray = value.split(/\s+/);
          console.log(lineArray);
          if (
            lineArray != null &&
            lineArray.length == 2 &&
            lineArray[0] != null &&
            lineArray[0] != "" &&
            lineArray[1] != null &&
            lineArray[1] != ""
          ) {
            var lessonRef = fb.db.collection("lessons").doc(this.lessonId);
            var studentRef = fb.db
              .collection("students")
              .doc(lineArray[0].toLowerCase())
              .get()
              .then(studentData => {
                var studentDetail;
                var saveStudent = true;
                if (studentData != null && studentData.exists) {
                  // studentData.ref.update({
                  // 'lessons': fb.firestore.FieldValue.arrayUnion(lessonRef)
                  // });
                  studentDetail = studentData.data();
                  this.addStudentToLesson(
                    lessonRef,
                    studentData,
                    studentDetail
                  );
                } else {
                  fb.db
                    .collection("students")
                    .where("register", "==", lineArray[1].toLowerCase())
                    .get()
                    .then(value => {
                      if (value.empty) {
                        studentDetail = {
                          code: lineArray[0].toLowerCase(),
                          register: lineArray[1].toLowerCase(),
                          // 'lessons': fb.firestore.FieldValue.arrayUnion(lessonRef),
                          created: fb.usersCollection.doc(
                            this.$store.getters.currentUser.uid
                          ),
                          createdAt: new Date()
                        };
                        studentData.ref.set(studentDetail);
                        this.addStudentToLesson(
                          lessonRef,
                          studentData,
                          studentDetail
                        );
                      }
                    });
                }
              });
          }
        });
        this.studentsText = "";
      }
    },
    addStudentToLesson(lessonRef, studentData, studentDetail) {
      studentData.ref
        .collection("lessonList")
        .doc(lessonRef.id)
        .get()
        .then(stLesson => {
          if (stLesson != null && stLesson.exists) {
          } else {
            studentData.ref
              .collection("lessonList")
              .doc(lessonRef.id)
              .set({
                lessonRef: lessonRef,
                addedDate: new Date(),
                addedUser: fb.usersCollection.doc(
                  this.$store.getters.currentUser.uid
                ),
                enabled: true,
                semester: this.lesson.semester
              });
          }
        });

      lessonRef
        .collection("studentList")
        .doc(studentData.id)
        .get()
        .then(lessonSt => {
          if (lessonSt != null && lessonSt.exists) {
          } else {
            lessonRef.update({
              numberOfStudents: fb.firestore.FieldValue.increment(1)
            });
            lessonRef
              .collection("studentList")
              .doc(studentData.id)
              .set({
                addedDate: new Date(),
                addedUser: fb.usersCollection.doc(
                  this.$store.getters.currentUser.uid
                ),
                studentRef: studentData.ref,
                enabled: true,
                semester: this.lesson.semester
              });
          }
        });
    },

    _editTopic(topic) {
      this.topic = Object.assign({}, topic);
      $("#exampleModal").modal("toggle");
    },
    _editContent(content, topic) {
      this.selectedTopic = topic;
      this.content = Object.assign({}, content);
      this.selectedType = content.type;
      $("#contentModal").modal("toggle");
    },
    _deleteTopic(topic, index, typeid) {
      var result = confirm("Та " + topic.name + " сэдвийг устгах уу?");
      if (result) {
        fb.db
          .collection("lessons")
          .doc(this.lessonId)
          .collection(typeid)
          .doc(topic.id)
          .delete();
      }
    },
    _deleteTopicFile(topic, content, file, index) {
      var result = confirm("Та " + file.fileName + " файлыг устгах уу?");
      if (result) {
        var fileName = file.uploadedAt.toDate().getTime() + "_" + file.fileName;
        var fileRef = fb.storageRef.child(this.topicBucket + fileName);
        fileRef
          .delete()
          .then(() => {
            content.files.splice(index, 1);
            fb.db
              .collection("lessons")
              .doc(this.lessonId)
              .collection("topics/" + topic.id + "/details")
              .doc(content.id)
              .update({
                files: content.files
              });
          })
          .catch(function(error) {});
      }
    },
    _deleteLessonFile(file, index) {
      var result = confirm("Та " + file.title + " файлыг устгах уу?");
      if (result) {
        var fileName = file.uploadedAt.toDate().getTime() + "_" + file.fileName;
        var fileRef = fb.storageRef.child(this.lessonBucket + fileName);
        // Delete the file
        fileRef
          .delete()
          .then(() => {
            this.lesson.files.splice(index, 1);
            fb.db
              .collection("lessons")
              .doc(this.lessonId)
              .update({
                files: this.lesson.files
              });
          })
          .catch(function(error) {});
      }
    },
    setEnabledForStudent(stddata, value) {
      this.setProperty("enabled", stddata.ref, value);
      this.setProperty(
        "enabled",
        fb.db.doc("students/" + stddata.id + "/lessonList/" + this.lessonId),
        value
      );
    },
    setProperty(propertyName, object, value) {
      if (object != null && propertyName != null) {
        var tmp = {};
        tmp[propertyName] = value;
        object.update(tmp);
      }
    },
    removeStudent(stddata) {
      fb.db
        .doc("students/" + stddata.id + "/lessonList/" + this.lessonId)
        .delete();
      stddata.ref.delete();
      fb.db
        .collection("lessons")
        .doc(this.lessonId)
        .update({
          numberOfStudents: fb.firestore.FieldValue.increment(-1)
        });
    },
    setPublished(value, lesson) {
      this.setProperty("published", fb.db.doc("lessons/" + lesson.id), value);
      if (value == true) {
        if (lesson.school != null && lesson.school != undefined)
          lesson.school.update({
            publishedLesson: fb.firestore.FieldValue.increment(1)
          });
        if (lesson.department != null && lesson.department != undefined)
          lesson.department.update({
            publishedLesson: fb.firestore.FieldValue.increment(1)
          });
        if (lesson.program != null && lesson.program != undefined)
          lesson.program.update({
            publishedLesson: fb.firestore.FieldValue.increment(1)
          });

        var publish = firebase.functions().httpsCallable("publishLesson");
        publish({ lessonId: lesson.id });
      } else {
        if (lesson.school != null && lesson.school != undefined)
          lesson.school.update({
            publishedLesson: fb.firestore.FieldValue.increment(-1)
          });
        if (lesson.department != null && lesson.department != undefined)
          lesson.department.update({
            publishedLesson: fb.firestore.FieldValue.increment(-1)
          });
        if (lesson.program != null && lesson.program != undefined)
          lesson.program.update({
            publishedLesson: fb.firestore.FieldValue.increment(-1)
          });
        var unpublish = firebase.functions().httpsCallable("unPublishLesson");
        unpublish({ lessonId: lesson.id });
      }
    },
    setProperty(propertyName, object, value) {
      if (object != null && propertyName != null) {
        var tmp = {};
        tmp[propertyName] = value;
        object.update(tmp);
      }
    },
    validFile(file) {
      if (
        file.fileName.endsWith("mp4") ||
        file.fileName.endsWith("MP4") ||
        file.fileName.endsWith("MPEG") ||
        file.fileName.endsWith("mov") ||
        file.fileName.endsWith("MOV") ||
        file.fileName.endsWith("webm") ||
        file.fileName.endsWith("WEBM")
      ) {
        return false;
      }
      return true;
    },
    getYoutubeId(url) {
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = url.match(regExp);

      return match && match[2].length === 11 ? match[2] : null;
    },
    getYoutubeIframe(url) {
      if (
        url != null &&
        url != "" &&
        url.toLowerCase().indexOf("youtube") != -1
      ) {
        var id = this.getYoutubeId(url);
        return "https://www.youtube.com/embed/" + id;
      }
      return null;
    }
  },
  computed: {
    ...mapState(["userProfile", "currentUser"])
  },
  props: {
    lessonId: {
      required: true
    }
  },
  created() {
    var _this = this;
    if (this.lessonId != null && this.lessonId != "") this._getQA();
  },
  filters: {
    formatDate(val) {
      if (val != null) {
        if (!val) {
          return "-";
        }
        let date = val.toDate();
        return moment(date).fromNow();
      }
      return "-";
    }
  }
};
</script>

